import {
  GET_SITESURVEYS,
  GET_SITESURVEYS_SUCCESS,
  GET_SITESURVEYS_FAIL,
  ADD_SITESURVEY,
  ADD_SITESURVEY_SUCCESS,
  ADD_SITESURVEY_FAIL,
  UPDATE_SITESURVEY,
  UPDATE_SITESURVEY_SUCCESS,
  UPDATE_SITESURVEY_FAIL,
  DELETE_SITESURVEY,
  DELETE_SITESURVEY_SUCCESS,
  DELETE_SITESURVEY_FAIL,
  SET_SITESURVEY_FIELD_ERRORS,
} from './actionTypes'

// Get SiteSurveys
export const getSiteSurveys = (userId, status, startDate, endDate, teamId, solutionId, sebelUserId, createdAt, displayLength = 10, displayStart = 0, sortCol = 0, sortDir = 'ASC', search = '') => ({
  type: GET_SITESURVEYS,
  payload: { status, startDate, endDate, teamId, userId, solutionId, sebelUserId, createdAt, displayLength, displayStart, sortCol, sortDir, search }
})

export const getSiteSurveysSuccess = (sitesurveys) => ({
  type: GET_SITESURVEYS_SUCCESS,
  payload: sitesurveys,
})

export const getSiteSurveysFail = (error) => ({
  type: GET_SITESURVEYS_FAIL,
  payload: error,
})

// Add SiteSurvey
export const addSiteSurvey = (sitesurvey, navigate) => ({
  type: ADD_SITESURVEY,
  payload: { sitesurvey, navigate },
})

export const addSiteSurveySuccess = (sitesurvey) => ({
  type: ADD_SITESURVEY_SUCCESS,
  payload: sitesurvey,
})

export const addSiteSurveyFail = (error) => ({
  type: ADD_SITESURVEY_FAIL,
  payload: error,
})

// Update SiteSurvey
export const updateSiteSurvey = (sitesurvey) => ({
  type: UPDATE_SITESURVEY,
  payload: sitesurvey,
})

export const updateSiteSurveySuccess = (sitesurvey) => ({
  type: UPDATE_SITESURVEY_SUCCESS,
  payload: sitesurvey,
})

export const updateSiteSurveyFail = (error) => ({
  type: UPDATE_SITESURVEY_FAIL,
  payload: error,
})

// Delete SiteSurvey
export const deleteSiteSurvey = (id) => ({
  type: DELETE_SITESURVEY,
  payload: id,
})

export const deleteSiteSurveySuccess = (id) => ({
  type: DELETE_SITESURVEY_SUCCESS,
  payload: id,
})

export const deleteSiteSurveyFail = (error) => ({
  type: DELETE_SITESURVEY_FAIL,
  payload: error,
})

// Set Field Errors
export const setSiteSurveyFieldErrors = (errors) => ({
  type: SET_SITESURVEY_FIELD_ERRORS,
  payload: errors,
})
